<template>
<div class="candidate-site-claim-source-wrapper">

    <div class="sub-headline">
        <h3>Including past and present political candidates</h3>
    </div>

    <div class="columns-separator">
        <div class="col left-side-charts">
            <vertical-chart 
                class="chart-item"
                title="By Party"
                sub-title=""
                :data="by_party_data"
                />
        </div>

        <div class="col center-side-charts">
            <vertical-chart 
                class="chart-item"
                title="By Level of Government"
                sub-title=""
                :data="by_level_of_gov_data"
                />
        </div>

        <div class="col right-side-charts">
            <vertical-chart 
                class="chart-item"
                title="Top Fact-Checked Candidate Sources"
                sub-title=""
                :data="top_fac_check_data"
                />
        </div>
    </div>
</div>
</template>

<script>

import VerticalChart from '../Charts/VerticalChart.vue';
import ClaimSourcesMixin from './ClaimSourcesMixin.js';

export default {
    name: '',
    components: {
        'vertical-chart': VerticalChart,
    },
    mixins: [
        ClaimSourcesMixin,
    ],
    data() {
        return {
            claim_method: 'claim_source_candidate_site',

            by_party_data: [],
            
            by_level_of_gov_data: [],

            top_fac_check_data: [],
        };
    },
    created(){
        this.getClaimSourceData();
    },
    methods: {
        async getClaimSourceData(){
            let data = await this.getData({}, this.claim_method);
            console.log("CLAIM SOURCE", data);
            this.by_party_data          = data.data.data.party_data;
            this.by_level_of_gov_data   = data.data.data.gov_data;
            this.top_fac_check_data     = data.data.data.candidates_data;
        },
    },
}
</script>

<style lang="scss">
.candidate-site-claim-source-wrapper{

    .sub-headline {
        background-color: #999;
        padding: 10px 10px;
        color: #fff;
        margin-top: 35px;

        h3{
            padding: 0px;
            margin: 0px;
        }
    }

    .columns-separator{
        display: flex;
        justify-content: space-between;
        .col{
            flex-basis: 50%;
            .chart-item{
                
            }

            &.left-side-charts{
                margin-right: 10px;
                .chart-item{
                
                }
            }

            &.center-side-charts{
                margin-right: 10px;
                margin-left: 10px;
                .chart-item{
                
                }
            }

            &.right-side-charts{
                margin-left: 10px;
                .chart-item{
                
                }
            }
        }
    }
}
</style>